import React from 'react'
import { observer } from 'mobx-react'
import { Button, Container, Row, Col } from 'react-bootstrap'
import { observable } from 'mobx'
import { UsersListCard } from './UsersListCard'
import { i18nTranslate, getContentFromCS, isFeatureEnabled } from 'src/utils'
import { APPConfig } from 'config/appConfig'
import './styles.scss'
import { renderUserInviteFormInput } from './userInviteFormInput'
import { userInviteFormschema } from './validationSchema'
import { CommonForm } from 'src/views/components'
import {
  customerContainer,
  userContainer,
  accountsContainer,
  storeContainer,
} from 'src/models'
import LoyaltyCard from '../../Privacy/LoyaltyCard'
import { ConfirmationModal } from './ConfirmationModal'
import { getLocaleCodeFromUrl, convertToBoolean } from 'src/utils'
import {
  parsePhoneNumberField,
  validLibMobilePhoneNumber,
  loadClickWrapContainer,
} from 'src/utils/signUpUtils'
import parse from 'html-react-parser'
import { participantsContainer } from 'src/models'
import {
  trackParticipantInviteEvent,
  trackParticipantSendInviteEvent,
} from 'src/utils/tracking'
@observer
class UsersList extends React.Component {
  @observable selectedTeam = 'All'
  @observable selectedRole = 'All'
  @observable searchUser = ''
  @observable isUserInviteFormOpen = false
  @observable showInviteButton = true
  @observable shouldShowConfirmationPopup = false
  formData = {}
  @observable participantPopupTextFromCS = ''

  constructor(props) {
    super(props)
    loadClickWrapContainer()
  }

  handleFilterChange = filterData => {
    this.props.handleSearchAndFilter(filterData)
  }
  handleChangeData = value => {
    this.props.handleSearchChangeData(value)
  }

  userList = user => {
    const { usersData } = this.props
    return (
      <UsersListCard
        userData={usersData}
        {...this.props}
        renderSendInviteButton={this.renderSendInviteButton}
      />
    )
  }
  getParticipantData = async () => {
    const signup_strings = await getContentFromCS('signup_strings')
    const enableJointAccountParticipants = convertToBoolean(
      APPConfig?.getAppConfig()?.enableJointAccountParticipants
    )
    if (enableJointAccountParticipants) {
      const userType =
        customerContainer?.profileResponse?.accounts?.accountType || ''
      if (userType === 'Brand Affiliate') {
        this.participantPopupTextFromCS = parse(
          signup_strings?.baIndividualParticipantPopup || ''
        )
        this.participantInviteConsentFromCS = parse(
          signup_strings?.baIndividualParticipantInviteConsent || ''
        )
      } else if (userType === 'Brand Affiliate - Business Entity') {
        this.participantPopupTextFromCS = parse(
          signup_strings?.baBeParticipantPopup || ''
        )
        this.participantInviteConsentFromCS = parse(
          signup_strings?.baBeParticipantInviteConsent || ''
        )
      }
    }
  }
  async componentDidMount() {
    await this.handleMarketChange()
    await this.getParticipantData()
  }
  handleMarketChange = () => {
    let homeCountry = ''
    customerContainer?.profileResponse?.accounts?.properties?.forEach(
      element => {
        if (element.attributeId === 'countryCode') {
          homeCountry = element.value
        }
      }
    )

    const curLocale =
      getLocaleCodeFromUrl({
        isReverseType: true,
        defaultLocale: 'en_US',
      }) || 'en_US'
    const [language, country] = curLocale.includes('_')
      ? curLocale.split('_')
      : curLocale.split('-')

    const enableJointAccountParticipants = convertToBoolean(
      APPConfig?.getAppConfig()?.enableJointAccountParticipants
    )

    const enableJointAccountParticipantsInvite = isFeatureEnabled(
      'enableJointAccountParticipantsInvite'
    )
    const isToEnableAssociateInvite =
      convertToBoolean(APPConfig?.getAppConfig()?.enableAssociateInvite) ||
      (enableJointAccountParticipants &&
        enableJointAccountParticipantsInvite) ||
      false

    this.showInviteButton =
      isToEnableAssociateInvite && homeCountry === country ? true : false
  }

  toggleUserInvitationForm = () => {
    this.isUserInviteFormOpen = !this.isUserInviteFormOpen
    if (this.isUserInviteFormOpen) {
      trackParticipantInviteEvent(customerContainer)
    }
  }

  renderSendInviteButton = () => {
    return (
      <Button
        variant="primary"
        className="send-intivation-button justify-content-center align-items-center"
        type="submit">
        {i18nTranslate('associate.sendInvitation', 'Send Invitation')}
      </Button>
    )
  }

  renderCancelFormButton = () => {
    return (
      <Button
        className="send-intivation-cancel-button justify-content-center align-items-center"
        variant="outline-primary"
        onClick={this.toggleUserInvitationForm}>
        {i18nTranslate('associate.cancel', 'Cancel')}
      </Button>
    )
  }

  handleSendInvitation = async (data = {}) => {
    const enableJointAccountParticipants = convertToBoolean(
      APPConfig?.getAppConfig()?.enableJointAccountParticipants
    )
    if (enableJointAccountParticipants) {
      const { phoneNumber, phoneCountryCode, ...remainingProps } = data
      let phone = ''
      if (phoneNumber !== '') {
        const phoneObj =
          (await parsePhoneNumberField(phoneNumber, phoneCountryCode)) || {}
        phone = phoneObj?.number || ''
      }
      const {
        firstName = '',
        lastName = '',
        accounts,
      } = customerContainer?.profileResponse

      const country = customerContainer?.getUserHomeCountry()
      const associateBuyerId = customerContainer?.userId || ''
      this.formData = {
        ...remainingProps,
        phoneNumber: phone,
        poAccountId:
          customerContainer.profileResponse?.accounts?.referenceAttribute?.toString() ||
          '',
        customProperties: {
          poUserType: accounts?.accountType || '',
          poAccountName: accounts?.name || '',
          poCountry: country,
          associateBuyerId: associateBuyerId,
        },
      }
      this.shouldShowConfirmationPopup = true
    } else {
      data = {
        ...data,
        poAccountId:
          customerContainer.profileResponse?.accounts?.referenceAttribute?.toString() ||
          '',
      }
      userContainer.sendAssociateInvitationLink(data)
      this.toggleUserInvitationForm()
    }
  }
  handleClosePopup = () => {
    this.shouldShowConfirmationPopup = false
  }

  inviteCallback = async () => {
    const isSuccess = await userContainer.sendAssociateInvitationLink(
      this.formData
    )
    if (isSuccess) {
      this.handleClosePopup()
      this.isUserInviteFormOpen = !this.isUserInviteFormOpen
      trackParticipantSendInviteEvent(customerContainer)
    }
  }
  customHandleBlur = async ({ values = {} }) => {
    if (values?.phoneNumber !== '') {
      const phoneNumberCode = await parsePhoneNumberField(
        values?.phoneNumber,
        values?.phoneCountryCode
      )
      const isValidMobile = await validLibMobilePhoneNumber(phoneNumberCode)
      accountsContainer.phoneNumberIsValid = isValidMobile
    } else {
      accountsContainer.phoneNumberIsValid = true
    }
  }

  getLimitForCurrentUserType = () => {
    const userType =
      customerContainer?.profileResponse?.accounts?.accountType || ''
    const associateConfig = storeContainer?.getAssociateConfig()
    let maxLimit = 0
    if (associateConfig?.maxAssociates) {
      maxLimit = associateConfig?.maxAssociates?.[userType] || 0
    }
    return maxLimit
  }
  renderHeader = () => {
    const enableJointAccountParticipants = convertToBoolean(
      APPConfig?.getAppConfig()?.enableJointAccountParticipants
    )

    const enableJointAccountParticipantsInvite = isFeatureEnabled(
      'enableJointAccountParticipantsInvite'
    )
    const { usersData } = this.props

    const maxInviteLimit = enableJointAccountParticipants
      ? this.getLimitForCurrentUserType()
      : 2
    const heading = enableJointAccountParticipants
      ? i18nTranslate('myaccount.participants', 'Participants')
      : i18nTranslate('usermanagement.heading', 'Associates')
    const inviteButtonText = enableJointAccountParticipants
      ? i18nTranslate('inviteParticipants.create', 'Invite Participants')
      : i18nTranslate('inviteuser.create', 'Invite Associates')

    const participantsResponse = participantsContainer.participantsResponse
    const length =
      (enableJointAccountParticipants
        ? participantsResponse?.pageableInfo?.totalCount
        : usersData?.length) || 0
    const shouldRenderButton = length < maxInviteLimit && this.showInviteButton
    const inviteButton = (
      <Button
        className="inviteuser-create-button"
        onClick={this.toggleUserInvitationForm}
        disabled={this.isUserInviteFormOpen}>
        {inviteButtonText}
      </Button>
    )

    if (enableJointAccountParticipants) {
      return (
        <Row
          noGutters
          className="bg-white invite-user-table position-relative mb-2 d-flex w-100">
          <h1 className="heading-2">{heading}</h1>
          {enableJointAccountParticipantsInvite &&
            this.participantInviteConsentFromCS && (
              <div className="participant-consent-title">
                {this.participantInviteConsentFromCS}
              </div>
            )}
          <div className="mt-3 participant-invite-button">
            {shouldRenderButton && inviteButton}
          </div>
        </Row>
      )
    } else {
      return (
        <div className="bg-white invite-user-table position-relative mb-2 d-flex justify-content-between">
          <h1 className="heading-2">{heading}</h1>
          {/* {this.props.isInvUserVisible === false && (
              <Button
                className="inviteuser-create-button"
                onClick={this.props.handleInviteUser}>
                {i18nTranslate("inviteuser.create", "Create")}
              </Button>
            )} */}
          {/*<DualDropDownWithSeachBar
              filterInput={formInput}
              title={usersTitle}
              handleChangeData={this.handleChangeData}
              onSubmit={this.handleFilterChange}
            />*/}
          {shouldRenderButton && inviteButton}
        </div>
      )
    }
  }

  render() {
    const formInput = renderUserInviteFormInput({ isFromUserListCard: false })
    const schema = userInviteFormschema({ isFromUserListCard: false })
    const { usersData } = this.props

    const isToEnableParticipantsTabLoyaltyOptIn =
      APPConfig?.getAppConfig()?.enableParticipantsTabLoyaltyOptIn || false

    return (
      <React.Fragment>
        {this.renderHeader()}

        {this.isUserInviteFormOpen && (
          <div className="bg-white p-3 user-invitation-form-container">
            <CommonForm
              schema={schema}
              formTypeJson={formInput}
              SubmitButtonProps={this.renderSendInviteButton}
              hasInlineSubmitButton={false}
              onSubmit={this.handleSendInvitation}
              customHandleBlur={this.customHandleBlur}
            />
            {this.renderCancelFormButton()}
          </div>
        )}

        <ConfirmationModal
          show={this.shouldShowConfirmationPopup}
          handleClose={this.handleClosePopup}
          content={this.participantPopupTextFromCS}
          inviteCallback={this.inviteCallback}
        />
        <Container className="p-0">{this.userList()}</Container>
        {isToEnableParticipantsTabLoyaltyOptIn && <LoyaltyCard />}
      </React.Fragment>
    )
  }
}

export default UsersList
export { UsersList }
